(() => {
  const bindHeader = (header) => {
    if (!header || header.dataset.bound === 'true') return;
    header.dataset.bound = 'true';
    const menu = header.querySelector('[data-yc-menu]');
    const openButton = header.querySelector('[data-yc-menu-open]');
    const closeButton = header.querySelector('[data-yc-menu-close]');
    const groups = [...header.querySelectorAll('.yc-menu__group')];
    const mobile = () => matchMedia('(max-width: 990px)').matches;
    const closeGroups = (except) => groups.forEach((group) => { if (group !== except) group.open = false; });
    const closeMenu = () => { menu?.classList.remove('is-open'); openButton?.setAttribute('aria-expanded', 'false'); document.body.classList.remove('yc-menu-open'); closeGroups(); };
    openButton?.addEventListener('click', () => { if (!mobile()) return; menu?.classList.add('is-open'); openButton.setAttribute('aria-expanded', 'true'); document.body.classList.add('yc-menu-open'); closeButton?.focus(); });
    closeButton?.addEventListener('click', closeMenu);
    groups.forEach((group) => group.addEventListener('toggle', () => { if (group.open) closeGroups(group); }));
    document.addEventListener('click', (event) => { if (!header.contains(event.target)) { closeGroups(); if (mobile()) closeMenu(); } });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeMenu(); });
    addEventListener('resize', () => { if (!mobile()) closeMenu(); });
  };
  const bindQuantities = (root = document) => {
    root.querySelectorAll('[data-yc-quantity]').forEach((input) => {
      const wrapper = input.closest('.yc-quantity');
      if (!wrapper || wrapper.dataset.bound === 'true') return;
      wrapper.dataset.bound = 'true';
      wrapper.querySelector('[data-yc-quantity-minus]')?.addEventListener('click', () => { input.value = Math.max(Number(input.min || 0), Number(input.value || 0) - 1); input.dispatchEvent(new Event('change', { bubbles: true })); });
      wrapper.querySelector('[data-yc-quantity-plus]')?.addEventListener('click', () => { input.value = Number(input.value || 0) + 1; input.dispatchEvent(new Event('change', { bubbles: true })); });
    });
  };
  const bindProduct = (root) => {
    if (!root || root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';
    const main = root.querySelector('[data-yc-product-main]');
    root.querySelectorAll('[data-yc-product-thumb]').forEach((button) => button.addEventListener('click', () => {
      if (main) { main.src = button.dataset.src; main.alt = button.dataset.alt || ''; }
      root.querySelectorAll('[data-yc-product-thumb]').forEach((item) => item.classList.toggle('is-active', item === button));
    }));
    const select = root.querySelector('[data-yc-variant-select]');
    select?.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      const available = option?.dataset.available === 'true';
      const price = root.querySelector('[data-yc-product-price]');
      const compare = root.querySelector('[data-yc-product-compare]');
      const stock = root.querySelector('[data-yc-stock-label]');
      const add = root.querySelector('[data-yc-product-add]');
      if (price) price.textContent = option?.dataset.price || '';
      if (compare) { compare.textContent = option?.dataset.compare || ''; compare.hidden = !option?.dataset.compare; }
      const main = root.querySelector('[data-yc-product-main]'); if (main && option?.dataset.image) main.src = option.dataset.image;
      if (stock) stock.textContent = available ? 'In stock' : 'Sold out';
      if (add) { add.disabled = !available; add.textContent = available ? 'Add to bag' : 'Sold out'; }
      const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url);
    });
  };
  const init = (root = document) => { root.querySelectorAll('[data-yc-header]').forEach(bindHeader); root.querySelectorAll('[data-yc-product]').forEach(bindProduct); bindQuantities(root); };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => init()) : init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
